/**
 * Подсказки о сомнительных значениях КБЖУ — прямо при вводе, до отправки.
 *
 * Разбор правок 1 сентября 2026: из 24 непустых четыре оказались с ошибками, и
 * все четыре — не злой умысел, а путаница. Чак-чак с 1831 ккал — это
 * килоджоули, вписанные в поле килокалорий; человек отправил и не заметил.
 * Подсказка на месте дешевле любой модерации и ловит ровно этот случай.
 *
 * Расчёт продублирован из lib/plausibility.js: сервер решает, уходит ли правка
 * в общую базу, клиент показывает текст. Числа обязаны совпадать — меняете
 * здесь, меняйте и там.
 */

// Спирт даёт 7 ккал/г и в БЖУ не попадает, поэтому на алкоголе Атуотер
// не сходится всегда. Список тот же, что на сервере.
const ALCOHOL_RE = /(вино|винный|пиво|водк|виски|ликёр|ликер|коньяк|ром |джин|шампан|наливк|настойк|сидр|вермут|текил|бренди|портвейн|wine|beer|vodka|whisky|whiskey|liqueur|rum|gin|cider|vermouth|tequila|brandy|alcool|alcohol)/i

const MAX_KCAL = 900
const MAX_MACRO_SUM = 100
const TOLERANCE = 0.2
const MIN_KCAL = 30
const MIN_ABS_DIFF = 20

const num = v => (v == null || v === '' || isNaN(Number(v))) ? null : Number(v)

/**
 * Возвращает массив подсказок — строк для показа под полями.
 * Пустой массив означает, что придраться не к чему.
 */
export function plausibilityHints({ name, kcal, protein, fat, carbs }) {
  const hints = []
  const k = num(kcal)
  const sum = (num(protein) || 0) + (num(fat) || 0) + (num(carbs) || 0)

  if (k != null && k > MAX_KCAL) {
    hints.push(`Калорийность не может быть выше ${MAX_KCAL} ккал на 100 г — столько даёт чистый жир. Проверьте, не килоджоули ли на упаковке: их делят на 4,2.`)
  }
  if (sum > MAX_MACRO_SUM) {
    hints.push(`Белки, жиры и углеводы вместе — ${Math.round(sum * 10) / 10} г, а в 100 г продукта их не может быть больше ${MAX_MACRO_SUM}.`)
  }
  if (ALCOHOL_RE.test(String(name || ''))) return hints

  const expected = (num(protein) || 0) * 4 + (num(carbs) || 0) * 4 + (num(fat) || 0) * 9
  if (k != null && k >= MIN_KCAL && expected > 0) {
    const diff = Math.abs(k - expected)
    if (diff > MIN_ABS_DIFF && diff / Math.max(k, expected) > TOLERANCE) {
      hints.push(`По белкам, жирам и углеводам получается около ${Math.round(expected)} ккал, а указано ${Math.round(k)}. Проверьте цифры с упаковки.`)
    }
  }
  return hints
}
